import { renderApp } from 'app/App'
import { sentry } from 'app/config/sentry'

export function startup(): void {
  sentry()
  renderApp()
}
